const BlogDetailStyles = () => {
  return (
    <style jsx>{`
      .blog-detail-page {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
          sans-serif;
      }

      /* Hero Section (Matching Home Page) */
      .blog-hero {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        padding: 100px 0 60px;
        position: relative;
        overflow: hidden;
      }

      .blog-hero::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(
            circle at 20% 80%,
            rgba(255, 215, 0, 0.1) 0%,
            transparent 50%
          ),
          radial-gradient(
            circle at 80% 20%,
            rgba(255, 255, 255, 0.05) 0%,
            transparent 50%
          );
      }

      .blog-hero-content {
        max-width: 100%;
        margin: 0 auto;
        position: relative;
        z-index: 1;
      }

      .blog-breadcrumb {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 24px;
        font-size: 14px;
      }

      .breadcrumb-link {
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        transition: color 0.3s ease;
      }

      .breadcrumb-link:hover {
        color: #ffd700;
      }

      .breadcrumb-separator {
        color: rgba(255, 255, 255, 0.5);
      }

      .breadcrumb-current {
        color: #ffd700;
        font-weight: 600;
      }

      .hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 24px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .badge-icon {
        font-size: 16px;
      }

      .badge-text {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .hero-title {
        font-size: clamp(2.5rem, 5vw, 3.5rem);
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
        word-wrap: break-word;
        background: linear-gradient(to right, #ffffff 0%, #e6f0ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .hero-excerpt {
        font-size: 1.25rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 40px;
        max-width: 700px;
      }

      .hero-meta {
        display: flex;
        align-items: center;
        gap: 24px;
        margin-bottom: 40px;
        flex-wrap: wrap;
      }

      .author-info {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .author-avatar {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid rgba(255, 215, 0, 0.3);
      }

      .author-details {
        display: flex;
        flex-direction: column;
      }

      .author-name {
        font-weight: 600;
        font-size: 16px;
      }

      .author-role {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }

      .meta-divider {
        width: 1px;
        height: 40px;
        background: rgba(255, 255, 255, 0.2);
      }

      .meta-details {
        display: flex;
        gap: 20px;
      }

      .meta-item {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .meta-icon {
        font-size: 16px;
      }

      .meta-text {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
      }

      .hero-share {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
      }

      .share-label {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }

      .share-buttons {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }

      .share-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        border-radius: 8px;
        border: none;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .share-btn.twitter {
        background: rgba(29, 161, 242, 0.2);
        color: #1da1f2;
        border: 1px solid rgba(29, 161, 242, 0.3);
      }

      .share-btn.linkedin {
        background: rgba(0, 119, 181, 0.2);
        color: #0077b5;
        border: 1px solid rgba(0, 119, 181, 0.3);
      }

      .share-btn.whatsapp {
        background: rgba(37, 211, 102, 0.2);
        color: #25d366;
        border: 1px solid rgba(37, 211, 102, 0.3);
      }

      .share-btn.copy {
        background: rgba(255, 255, 255, 0.1);
        color: white;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .share-btn:hover {
        transform: translateY(-2px);
        opacity: 0.9;
      }

      .hero-bg-elements {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
      }

      .bg-circle-1 {
        position: absolute;
        top: 20%;
        left: 10%;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background: rgba(255, 215, 0, 0.1);
        filter: blur(40px);
      }

      .bg-circle-2 {
        position: absolute;
        bottom: 30%;
        right: 15%;
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.05);
        filter: blur(50px);
      }

      /* Featured Image */
      .featured-image-section {
        padding: 40px 0;
        background: white;
      }

      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
      }

      .featured-image-wrapper {
        margin: 0 auto;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
      }

      .featured-image {
        width: 100%;
        height: auto;
        display: block;
      }

      .image-caption {
        padding: 16px;
        background: #f8fafc;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #64748b;
        border-top: 1px solid #e2e8f0;
      }

      /* Main Content */
      .main-content-section {
        padding: 60px 0;
        background: #f8fafc;
      }

      .toc-toggle-btn {
        display: none;
        width: 100%;
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;
        font-weight: 600;
        color: #0a2458;
        cursor: pointer;
        justify-content: space-between;
        align-items: center;
      }

      .mobile-toc {
        display: none;
        background: white;
        border-radius: 12px;
        padding: 24px;
        margin-bottom: 30px;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
      }

      .content-grid {
        display: grid;
        grid-template-columns: 300px 1fr;
        gap: 60px;
      }

      .toc-sidebar {
        position: relative;
      }

      .toc-sticky {
        position: sticky;
        top: 100px;
      }

      .toc-header {
        margin-bottom: 24px;
      }

      .toc-title {
        font-size: 1.25rem;
        color: #0a2458;
        margin-bottom: 12px;
      }

      .toc-progress {
        margin-bottom: 20px;
      }

      .progress-bar {
        height: 4px;
        background: #e2e8f0;
        border-radius: 2px;
        margin-bottom: 8px;
        overflow: hidden;
      }

      .progress-fill {
        height: 100%;
        width: 30%;
        background: linear-gradient(90deg, #0a2458, #1a3b8a);
        border-radius: 2px;
      }

      .progress-text {
        font-size: 12px;
        color: #64748b;
      }

      .toc-list {
        list-style: none;
        padding: 0;
        margin: 0 0 24px 0;
      }

      .toc-item {
        margin-bottom: 8px;
      }

      .toc-link {
        width: 100%;
        text-align: left;
        background: transparent;
        border: none;
        padding: 12px 16px;
        border-radius: 8px;
        color: #475569;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .toc-link:hover {
        background: #f0f7ff;
        color: #0a2458;
        transform: translateX(5px);
      }

      .toc-number {
        font-weight: 600;
        color: #0a2458;
        min-width: 24px;
      }

      .toc-title-text {
        flex: 1;
        text-align: left;
      }

      .toc-cta {
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f0ff 100%);
        border-radius: 12px;
        padding: 20px;
        border: 1px solid rgba(10, 36, 88, 0.1);
      }

      .cta-icon {
        font-size: 32px;
        margin-bottom: 12px;
      }

      .cta-content h4 {
        font-size: 16px;
        color: #0a2458;
        margin-bottom: 4px;
      }

      .cta-content p {
        font-size: 14px;
        color: #64748b;
        margin-bottom: 12px;
      }

      .cta-btn {
        display: inline-block;
        padding: 8px 16px;
        background: #0a2458;
        color: white;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.3s ease;
      }

      .cta-btn:hover {
        background: #1a3b8a;
        transform: translateY(-2px);
      }

      /* Article Content */
      .article-content {
        background: white;
        border-radius: 20px;
        padding: 48px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
      }

      .blog-content {
        font-size: 18px;
        line-height: 1.8;
        color: #334155;
      }

      .blog-content h2 {
        font-size: 2rem;
        color: #0a2458;
        padding-bottom: 0.5em;
        border-bottom: 2px solid #f0f7ff;
      }

      .blog-content h3 {
        font-size: 1.5rem;
        color: #1a3b8a;
      }

      .blog-content p {
        color: #475569;
      }

      .blog-content ul,
      .blog-content ol {
        padding-left: 2em;
        color: #475569;
      }

      .blog-content li {
        margin: 0.5em 0;
      }

      .blog-content strong {
        color: #0a2458;
      }

      .callout-box {
        background: #f0f7ff;
        border-left: 4px solid #0a2458;
        padding: 24px;
        border-radius: 0 12px 12px 0;
        margin: 2em 0;
      }

      .example-box {
        background: #fff7ed;
        border: 1px solid #fed7aa;
        padding: 20px;
        border-radius: 12px;
        margin: 2em 0;
      }

      .stats-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        margin: 2em 0;
      }

      .stat {
        background: white;
        border: 1px solid #e2e8f0;
        padding: 24px;
        border-radius: 12px;
        text-align: center;
      }

      .stat h4 {
        font-size: 2rem;
        color: #0a2458;
        margin-bottom: 8px;
      }

      .stat p {
        color: #64748b;
        margin: 0;
      }

      .cost-breakdown {
        overflow-x: auto;
        margin: 2em 0;
      }

      .table {
        width: 100%;
        border-collapse: collapse;
      }

      .table th {
        background: #f0f7ff;
        color: #0a2458;
        padding: 16px;
        text-align: left;
        border: 1px solid #e2e8f0;
      }

      .table td {
        padding: 16px;
        border: 1px solid #e2e8f0;
        color: #475569;
      }

      .table-active {
        background: #f0f7ff;
        font-weight: 600;
      }

      .highlight-text {
        background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
        padding: 20px;
        border-radius: 12px;
        font-size: 1.25rem;
        color: #92400e;
        text-align: center;
        margin: 2em 0;
        border: 1px solid #fcd34d;
      }

      .checklist-box {
        background: #f0fdf4;
        border: 1px solid #bbf7d0;
        padding: 24px;
        border-radius: 12px;
        margin: 2em 0;
      }

      .framework-box {
        background: #faf5ff;
        border: 1px solid #e9d5ff;
        padding: 24px;
        border-radius: 12px;
        margin: 2em 0;
      }

      .cta-box {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        padding: 40px;
        border-radius: 16px;
        margin: 3em 0;
        text-align: center;
      }

      .cta-box h3 {
        color: white;
        margin-bottom: 16px;
      }

      .cta-box p {
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 24px;
      }

      .cta-box .btn {
        background: #ffd700;
        color: #0a2458;
        border: none;
        padding: 16px 32px;
        font-weight: 600;
        border-radius: 12px;
        transition: all 0.3s ease;
      }

      .cta-box .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(255, 215, 0, 0.3);
      }

      .article-tags {
        margin-top: 60px;
        padding-top: 40px;
        border-top: 1px solid #e2e8f0;
      }

      .tags-title {
        font-size: 1.25rem;
        color: #0a2458;
        margin-bottom: 20px;
      }

      .tags-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
      }

      .tag-item {
        background: #f0f7ff;
        color: #0a2458;
        padding: 8px 16px;
        border-radius: 50px;
        font-size: 14px;
        text-decoration: none;
        transition: all 0.3s ease;
        border: 1px solid rgba(10, 36, 88, 0.1);
      }

      .tag-item:hover {
        background: #0a2458;
        color: white;
        transform: translateY(-2px);
      }

      .author-bio-card {
        background: #f8fafc;
        border-radius: 16px;
        padding: 32px;
        margin-top: 60px;
        border: 1px solid #e2e8f0;
      }

      .author-header {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 20px;
      }

      .author-bio-avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        object-fit: cover;
        border: 3px solid #0a2458;
      }

      .author-info h3 {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 4px;
      }

      .author-info p {
        color: #64748b;
        margin: 0;
      }

      .author-bio {
        font-size: 16px;
        line-height: 1.6;
        color: #475569;
        margin-bottom: 20px;
      }

      .author-social {
        display: flex;
        gap: 20px;
      }

      .social-link {
        color: #0a2458;
        text-decoration: none;
        font-weight: 500;
        transition: color 0.3s ease;
      }

      .social-link:hover {
        color: #1a3b8a;
      }

      .share-again {
        text-align: center;
        margin-top: 60px;
        padding: 40px;
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f0ff 100%);
        border-radius: 16px;
      }

      .share-title {
        font-size: 1.5rem;
        color: #0a2458;
        margin-bottom: 8px;
      }

      .share-subtitle {
        color: #64748b;
        margin-bottom: 24px;
      }

      .share-buttons-large {
        display: flex;
        gap: 16px;
        justify-content: center;
      }

      .share-btn-lg {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px 32px;
        border-radius: 12px;
        border: none;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .share-btn-lg.twitter {
        background: #1da1f2;
        color: white;
      }

      .share-btn-lg.linkedin {
        background: #0077b5;
        color: white;
      }

      .share-btn-lg:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
      }

      /* Related Posts */
      .related-posts-section {
        padding: 80px 0;
        background: white;
      }

      .section-header {
        text-align: center;
        margin-bottom: 60px;
      }

      .section-title {
        font-size: 2.5rem;
        color: #0a2458;
        margin-bottom: 12px;
      }

      .section-subtitle {
        font-size: 1.125rem;
        color: #64748b;
        max-width: 600px;
        margin: 0 auto;
      }

      .related-posts-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
        margin-bottom: 60px;
      }

      .related-post-card {
        background: white;
        border-radius: 16px;
        overflow: hidden;
        text-decoration: none;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        display: block;
      }

      .related-post-card:hover {
        transform: translateY(-10px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
      }

      .post-image-wrapper {
        position: relative;
        height: 200px;
        overflow: hidden;
      }

      .post-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .related-post-card:hover .post-image {
        transform: scale(1.05);
      }

      .post-category {
        position: absolute;
        top: 16px;
        left: 16px;
        background: rgba(10, 36, 88, 0.9);
        color: white;
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
      }

      .post-content {
        padding: 24px;
      }

      .post-title {
        font-size: 1.25rem;
        color: #0a2458;
        margin-bottom: 12px;
        line-height: 1.4;
      }

      .post-meta {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .post-read-time {
        font-size: 14px;
        color: #64748b;
      }

      .post-arrow {
        padding: 0 24px 24px;
        color: #0a2458;
        font-size: 20px;
        font-weight: 600;
      }

      .cta-section {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 24px;
        padding: 60px;
        text-align: center;
        color: white;
      }

      .cta-title {
        font-size: 2rem;
        margin-bottom: 16px;
      }

      .cta-text {
        font-size: 1.125rem;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 32px;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
      }

      .cta-buttons {
        display: flex;
        gap: 20px;
        justify-content: center;
        flex-wrap: wrap;
      }

      .cta-btn-primary {
        background: #ffd700;
        color: #0a2458;
        padding: 16px 32px;
        border-radius: 12px;
        font-weight: 600;
        text-decoration: none;
        transition: all 0.3s ease;
      }

      .cta-btn-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(255, 215, 0, 0.3);
      }

      .cta-btn-secondary {
        background: transparent;
        color: white;
        padding: 16px 32px;
        border-radius: 12px;
        font-weight: 600;
        text-decoration: none;
        border: 2px solid rgba(255, 255, 255, 0.3);
        transition: all 0.3s ease;
      }

      .cta-btn-secondary:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-2px);
      }

      /* Responsive Design */
      @media (max-width: 992px) {
        .content-grid {
          grid-template-columns: 1fr;
          gap: 40px;
        }

        .toc-sidebar {
          display: none;
        }

        .toc-toggle-btn {
          display: flex;
        }

        .mobile-toc {
          display: block;
        }

        .article-content {
          padding: 32px;
        }

        .stats-box {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 768px) {
        .blog-hero {
          padding: 80px 0 40px;
        }

        .hero-title {
          font-size: 2rem;
        }

        .hero-excerpt {
          font-size: 1.125rem;
        }

        .hero-meta {
          flex-direction: column;
          align-items: flex-start;
          gap: 20px;
        }

        .meta-divider {
          display: none;
        }

        .hero-share {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
        }

        .share-buttons {
          width: 100%;
        }

        .share-btn {
          flex: 1;
          justify-content: center;
        }

        .article-content {
          padding: 24px;
        }

        .blog-content {
          font-size: 16px;
        }

        .blog-content h2 {
          font-size: 1.75rem;
        }

        .blog-content h3 {
          font-size: 1.25rem;
        }

        .related-posts-grid {
          grid-template-columns: 1fr;
        }

        .cta-section {
          padding: 40px 20px;
        }

        .cta-buttons {
          flex-direction: column;
        }

        .cta-btn-primary,
        .cta-btn-secondary {
          width: 100%;
          text-align: center;
        }

        .share-buttons-large {
          flex-direction: column;
        }

        .share-btn-lg {
          width: 100%;
          justify-content: center;
        }
      }

      @media (max-width: 480px) {
        .hero-title {
          font-size: 1.75rem;
        }

        .section-title {
          font-size: 2rem;
        }

        .author-header {
          flex-direction: column;
          text-align: center;
        }

        .author-info {
          text-align: center;
        }

        .author-social {
          justify-content: center;
        }
      }
    `}</style>
  );
};
export default BlogDetailStyles;
